<template lang="pug">
    components(:is="transformed")
</template>

<script>
export default {
    props: ["template"],
    computed: {
        transformed() {
            return { template: this.template };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/TransformHtml.vue